/**
 * API Road Alert - Basé sur la collection Postman alerte_road
 * Base URL: https://api-alerte.didodigit.com/api
 */

import { APIClient } from "helpers/api_helper";

const apiClient = new APIClient();

// Auth (sans Bearer token) - utilise axiosNoAuth pour ne jamais envoyer de token
export const login = async (data: { username: string; password: string }) => {
  return await apiClient.post("/api/auth/login", false, data);
};

// Paramètres - Régions
export const createRegion = (data: { data: { libelleRegion: string } }) =>
  apiClient.post("/api/region/create", true, data);
export const getRegionsByCriteria = (data: { user?: number; data?: Record<string, unknown> }) =>
  apiClient.post("/api/region/getByCriteria", true, data);
export const updateRegion = (data: {
  data: { idRegion: number; libelleRegion: string };
}) => apiClient.post("/api/region/update", true, data);
export const deleteRegion = (payload: { data: { idRegion: number | string } }) =>
  apiClient.post("/api/region/delete", true, { data: { idRegion: payload.data.idRegion } });

// Paramètres - Départements
export const createDepartement = (data: { data: { libelleDepartement: string; idRegion: string } }) =>
  apiClient.post("/api/departement/create", true, data);
export const getDepartementsByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/departement/getByCriteria", true, data);
export const updateDepartement = (data: {
  data: { idDepartement: number; libelleDepartement: string; idRegion: string };
}) => apiClient.post("/api/departement/update", true, data);
export const deleteDepartement = (payload: { data: { idDepartement: number | string } }) =>
  apiClient.post("/api/departement/delete", true, { data: { idDepartement: payload.data.idDepartement } });

// Paramètres - Communes
export const createCommune = (data: { data: { libelleCommune: string; idDepartement: string } }) =>
  apiClient.post("/api/communes/create", true, data);
export const getCommunesByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/communes/getByCriteria", true, data);

// Paramètres - Types et référentiels
export const getTypeChausseByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/typeChausse/getByCriteria", true, data);
export const createTypeChausse = (data: { data: { libelleTypeChausse: string } }) =>
  apiClient.post("/api/typeChausse/create", true, data);
export const updateTypeChausse = (data: {
  data: { idTypeChausse: number; libelleTypeChausse: string };
}) => apiClient.post("/api/typeChausse/update", true, data);
export const deleteTypeChausse = (payload: { data: { idTypeChausse: number | string } }) =>
  apiClient.post("/api/typeChausse/delete", true, { data: { idTypeChausse: payload.data.idTypeChausse } });
export const getTypeDegradationByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/typedegradation/getByCriteria", true, data);
export const createTypeDegradation = (data: { data: { libelleTypeDegradation: string } }) =>
  apiClient.post("/api/typedegradation/create", true, data);
export const updateTypeDegradation = (data: {
  data: { idTypeDegradation: number; libelleTypeDegradation: string };
}) => apiClient.post("/api/typedegradation/update", true, data);
/** Supprime un type de dégradation. Body envoyé : { data: { idTypeDegradation } } */
export const deleteTypeDegradation = (payload: { data: { idTypeDegradation: number | string } }) =>
  apiClient.post("/api/typedegradation/delete", true, { data: { idTypeDegradation: payload.data.idTypeDegradation } });
export const getFamilleDegradationByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/familledegradation/getByCriteria", true, data);
export const createFamilleDegradation = (data: {
  data: { libelleEnsDegradation: string; idTypeDegradation: string | number };
}) => apiClient.post("/api/familledegradation/create", true, data);
export const updateFamilleDegradation = (data: {
  data: { idEnsDegradation: number; libelleEnsDegradation: string; idTypeDegradation: string | number };
}) => apiClient.post("/api/familledegradation/update", true, data);
export const deleteFamilleDegradation = (payload: { data: { idEnsDegradation: number | string } }) =>
  apiClient.post("/api/familledegradation/delete", true, { data: { idEnsDegradation: payload.data.idEnsDegradation } });
export const getDegradationByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/degradation/getByCriteria", true, data);
export const createDegradation = (data: {
  data: { libelleDegradation: string; idEnsDegradation: string | number };
}) => apiClient.post("/api/degradation/create", true, data);
export const updateDegradation = (data: {
  data: { idDegradation: number; libelleDegradation: string; idEnsDegradation: string | number };
}) => apiClient.post("/api/degradation/update", true, data);
export const deleteDegradation = (payload: { data: { idDegradation: number | string } }) =>
  apiClient.post("/api/degradation/delete", true, { data: { idDegradation: payload.data.idDegradation } });
export const getNiveauGraviteByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/niveauGravite/getByCriteria", true, data);
export const createNiveauGravite = (data: { data: { libelleNiveauGravite: string; notation: string } }) =>
  apiClient.post("/api/niveauGravite/create", true, data);
export const updateNiveauGravite = (data: {
  data: { idNiveauGravite: number; libelleNiveauGravite: string; notation: string };
}) => apiClient.post("/api/niveauGravite/update", true, data);
export const deleteNiveauGravite = (data: { data: { idNiveauGravite: number } }) =>
  apiClient.post("/api/niveauGravite/delete", true, data);
export const getParametreByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/parametre/getByCriteria", true, data);
export const createParametre = (data: {
  data: { libelleParametre: string; valeur: string };
}) => apiClient.post("/api/parametre/create", true, data);
export const updateParametre = (data: {
  data: { idParametre: number; libelleParametre: string; valeur: string };
}) => apiClient.post("/api/parametre/update", true, data);
export const deleteParametre = (payload: { data: { idParametre: number | string } }) =>
  apiClient.post("/api/parametre/delete", true, { data: { idParametre: payload.data.idParametre } });
export const getTypeTravauxByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/typeTravaux/getByCriteria", true, data);
export const getStatutAlerteByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/statutAlerte/getByCriteria", true, data);
export const getPrioriteByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/priorite/getByCriteria", true, data);
export const getTypeAlerteByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/typealerte/getByCriteria", true, data);
export const createTypeAlerte = (data: { data: { libTypeAlerte: string } }) =>
  apiClient.post("/api/typealerte/create", true, data);
export const updateTypeAlerte = (data: {
  data: { idTypeAlerte: number; libTypeAlerte: string };
}) => apiClient.post("/api/typealerte/update", true, data);
export const deleteTypeAlerte = (payload: { data: { idTypeAlerte: number | string } }) =>
  apiClient.post("/api/typealerte/delete", true, { data: { idTypeAlerte: payload.data.idTypeAlerte } });
export const getChefEquipeByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/chefEquipe/getByCriteria", true, data);
export const getEquipesByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/equipe/getByCriteria", true, data);
export const getUsersByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/users/getByCriteria", true, data);

// Users - Inscription
export const registerUser = (data: {
  data: {
    name: string;
    email: string;
    mobile: string;
    username: string;
    password: string;
    passwordConfirm: string;
  };
}) => apiClient.post("/api/users/inscription", false, data);

// Roles
export const getRolesByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/role/getByCriteria", true, data);

// Alertes
export const createAlerte = (data: { data: Record<string, unknown> }) =>
  apiClient.post("/api/alertes/create", true, data);
export const deleteAlerte = (payload: { data: { idAlerte: number | string } }) =>
  apiClient.post("/api/alertes/delete", true, { data: { idAlerte: payload.data.idAlerte } });
export const getAlertesByCriteria = (payload: {
  user?: string;
  data?: Record<string, unknown>;
  page?: number;
  size?: number;
}) => apiClient.post("/api/alertes/getByCriteria", true, payload);
export const getAlerteEnCours = (data: { data: { idAlerte: string } }) =>
  apiClient.post("/api/alertes/enCours", true, data);
/** Valider une alerte « non démarrée » → passage en « en cours » (idStatutAlerte = 6) */
export const validerAlerteEnCours = (data: { data: { idAlerte: number; idStatutAlerte: number } }) =>
  apiClient.post("/api/alertes/enCours", true, data);
export const getAlerteNbreStat = (data: { user?: string; data?: Record<string, unknown> }) =>
  apiClient.post("/api/alertes/getnbreStat", true, data);
export const affectationEquipe = (data: { data: Record<string, unknown> }) =>
  apiClient.post("/api/alertes/affectationEquipe", true, data);
export const affectationEquipeMultiple = (data: { data: Record<string, unknown> }) =>
  apiClient.post("/api/alertes/affectationEquipemultiple", true, data);
export const getPointHebdomadaire = (data: { data: Record<string, unknown> }) =>
  apiClient.post("/api/alertes/pointhebdomadaire", true, data);
export const addSurfaceTraitee = (data: { data: { idAlerte: number; surfaceTraite: string } }) =>
  apiClient.post("/api/surfaceTraite/create", true, data);

// Documents et dégradations des alertes
export const getAlertesDocByCriteria = (data: { data: { idAlerte: number } }) =>
  apiClient.post("/api/alertesDoc/getByCriteria", true, data);
export const getAlertesDegradationByCriteria = (data: { data: { idAlerte: number } }) =>
  apiClient.post("/api/alertesDegradation/getByCriteria", true, data);

// Surface traitée - Statistiques
export const getSurfaceTraiteeByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/surfacetraite/getByCriteria", true, data);
export const getItiSurfaceTraiteeByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/itisurfacetraite/getByCriteria", true, data);
export const getDepSurfaceTraiteeByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/depSurfTraitee/getByCriteria", true, data);
export const getCumulItineraireByCriteria = (data: { data?: Record<string, unknown> }) =>
  apiClient.post("/api/cumulItineraire/getByCriteria", true, data);

/* Exportation de données */
